/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { SortFilterListPendingAuthorizationOrder } from '../model/sortFilterListPendingAuthorizationOrder';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class FileDownloadService {

    protected basePath = 'http://localhost:3402';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Streams the requested file to the client
     * Takes a id of a file and then streams it back to the requester.  MIME types will be set in the header        Sample Call      http://URL/api/FileDownload/{id}
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fileDownloadGetFile(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public fileDownloadGetFile(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public fileDownloadGetFile(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public fileDownloadGetFile(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling fileDownloadGetFile.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/api/FileDownload/Excel/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param guid 
     * @param fileName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fileDownloadRenderDocument(guid: string, fileName?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public fileDownloadRenderDocument(guid: string, fileName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public fileDownloadRenderDocument(guid: string, fileName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public fileDownloadRenderDocument(guid: string, fileName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (guid === null || guid === undefined) {
            throw new Error('Required parameter guid was null or undefined when calling fileDownloadRenderDocument.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fileName !== undefined && fileName !== null) {
            queryParameters = queryParameters.set('fileName', <any>fileName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/api/FileDownload/PDF/${encodeURIComponent(String(guid))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generates a PDF download with a filename from the document type.   The link is generated in  LinkTemplates.DocuTrackDocument.GetDownloadLinkForDocumentType()
     * 
     * @param guid 
     * @param docType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fileDownloadRenderDocumentWithSpecifiedFilename(guid: string, docType: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public fileDownloadRenderDocumentWithSpecifiedFilename(guid: string, docType: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public fileDownloadRenderDocumentWithSpecifiedFilename(guid: string, docType: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public fileDownloadRenderDocumentWithSpecifiedFilename(guid: string, docType: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (guid === null || guid === undefined) {
            throw new Error('Required parameter guid was null or undefined when calling fileDownloadRenderDocumentWithSpecifiedFilename.');
        }

        if (docType === null || docType === undefined) {
            throw new Error('Required parameter docType was null or undefined when calling fileDownloadRenderDocumentWithSpecifiedFilename.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/api/FileDownload/PDF/${encodeURIComponent(String(docType))}/${encodeURIComponent(String(guid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * &lt;remarks&gt;              Takes an object that contains a list of objects containing a guid and a sort order (if blank use the default) and return an object containing a merged PDF file and file name                  Sample Call                  http://URL/api/FileDownload/PDF/ListMerged/              &lt;/remarks&gt;
     * 
     * @param ordersAndFilters 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fileDownloadRenderListMergedDocument(ordersAndFilters: SortFilterListPendingAuthorizationOrder, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public fileDownloadRenderListMergedDocument(ordersAndFilters: SortFilterListPendingAuthorizationOrder, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public fileDownloadRenderListMergedDocument(ordersAndFilters: SortFilterListPendingAuthorizationOrder, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public fileDownloadRenderListMergedDocument(ordersAndFilters: SortFilterListPendingAuthorizationOrder, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (ordersAndFilters === null || ordersAndFilters === undefined) {
            throw new Error('Required parameter ordersAndFilters was null or undefined when calling fileDownloadRenderListMergedDocument.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/FileDownload/PDF/ListMerged`,
            ordersAndFilters,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param guids 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fileDownloadRenderMergedDocument(guids: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public fileDownloadRenderMergedDocument(guids: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public fileDownloadRenderMergedDocument(guids: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public fileDownloadRenderMergedDocument(guids: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (guids === null || guids === undefined) {
            throw new Error('Required parameter guids was null or undefined when calling fileDownloadRenderMergedDocument.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/api/FileDownload/PDF/Merged/${encodeURIComponent(String(guids))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
